import React, { Component, Fragment, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import props from "prop-types";
import _ from 'lodash';
import moment from 'moment';
import DatePicker from "react-datepicker";
import { Grid, Segment, Input, Button, Icon, Table, Modal, Form, Pagination } from 'semantic-ui-react';
import { setActivePage, showLoading, hideLoading, getSalesReports, getSalesReportsById, sortSalesReports, exportSales } from '../actions';
import trans from '../assets/img/transparent_image.png';
import "react-datepicker/dist/react-datepicker.css";
import ReactApexChart from 'react-apexcharts'

const periodOptions = [
  { key: 'Monthly', text: 'Month', value: 'Monthly' },
  { key: 'Yearly', text: 'Year', value: 'Yearly' }
]

const monthOptions = [
  { key: '0', text: 'Jan', value: 0 },
  { key: '1', text: 'Feb', value: 1 },
  { key: '2', text: 'Mar', value: 2 },
  { key: '3', text: 'Apr', value: 3 },
  { key: '4', text: 'May', value: 4 },
  { key: '5', text: 'Jun', value: 5 },
  { key: '6', text: 'Jul', value: 6 },
  { key: '7', text: 'Aug', value: 7 },
  { key: '8', text: 'Sep', value: 8 },
  { key: '9', text: 'Oct', value: 9 },
  { key: '10', text: 'Nov', value: 10 },
  { key: '11', text: 'Dec', value: 11 }
]

class SalesReport extends React.Component {

  //Only can put one this state
  //Two state may collapse, and only show one state data
  constructor(props) {
    super(props);
    let now = new Date();
    this.year = now.getFullYear();
    this.month = now.getMonth();
    this.yearOptions = _.range(this.year, this.year - 10, -1).map(year => { return { key: year, text: year, value: year } });
    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      selectedStartDate: null,
      selectedEndDate: null,
      column: null,
      summary: null,
      data: [],
      length: 0,
      direction: null,
      page: 0,
      rowsPerPage: 20, // rows that will show one page of the table
      addSalesReportsModal: false,
      newSalesReports: {
        order_date: [],
        order_details: {
          total_amount: ''
        }
      },
      selectedPeriod: 'Monthly',
      selectedYear: this.year,
      selectedMonth: this.month,
      exportHtml: null,
      options: {
        labels: [],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },
      series: [],
    };
    this.handleChangeStart = this.handleChangeStart.bind(this);
    this.handleChangeEnd = this.handleChangeEnd.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    window.Handlebars.registerHelper('currency', function (value) {
      return value.toFixed(2);
    });
    window.Handlebars.registerHelper('date', function (date) {
      return moment(date).format('DD/MM/YYYY');
    });
    window.Handlebars.registerHelper('math', function (lvalue, operator, rvalue, options) {
      lvalue = parseFloat(lvalue);
      rvalue = parseFloat(rvalue);

      return {
        "+": lvalue + rvalue,
        "-": lvalue - rvalue,
        "*": lvalue * rvalue,
        "/": lvalue / rvalue,
        "%": lvalue % rvalue
      }[operator];
    });
    window.Handlebars.registerHelper('ifDiffEq', function (a, b, c, options) {
      if ((a - b) === c) {
        return options.fn(this);
      } else {
        return options.inverse(this);
      }
    });
    window.Handlebars.registerHelper('index', function (rows, pages, items) {
      return (parseInt(rows) * parseInt(pages)) + parseInt(items) + 1;
    });
    this.props.getSalesReports(this.state.startDate, this.state.endDate);
  }


  componentDidMount() {
    this.props.setActivePage('sales');
  }

  handleChangeStart(date) {
    this.setState({
      startDate: date
    });
  }

  handleChangeEnd(date) {
    this.setState({
      endDate: date
    });
  }


  //Push Selected Start Date to the data to send
  handleStartDateInput(date) {
    this.setState({
      selectedStartDate: {
        ...this.state.selectedStartDate,
        [date.target.startDate]: date.target.value
      }
    });
  }

  handleEndDateInput(date) {
    this.setState({
      selectedEndDate: {
        ...this.state.selectedStartDate,
        [date.target.startDate]: date.target.value
      }
    });
  }

  //Send data to API to receive order_details
  handleGetSalesReports() {
    this.props.getSalesReports(this.state.startDate, this.state.endDate);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.sales.list !== nextProps.sales.list) {
      console.log(nextProps.sales.list);

      this.setState({
        options: {
          labels: nextProps.sales.list.map(sales => {
            let labeldate = [];
            labeldate = moment(sales.order_date).format('DD/MM/YYYY HH:mm');
            return labeldate;
          }
          )
        },
        series: nextProps.sales.list.map(sales => {
          let s = [];
          s = sales.order_details.total_amount;
          return s;
        }
        )
      }
      );

      console.log(this.state.series.length)

      this.setState({ data: _.chunk(nextProps.sales.list, this.state.rowsPerPage), length: nextProps.sales.list.length, column: nextProps.sales.sortColumn, direction: nextProps.sales.sortDirection, summary: nextProps.sales.summary, selectedStartDate: this.state.startDate, selectedEndDate: this.state.endDate });
      this.props.hideLoading();
    } else if ((this.props.sales.sortColumn !== nextProps.sales.sortColumn) || (this.props.sales.sortDirection !== nextProps.sales.sortDirection)) {
      this.setState({ data: _.chunk(nextProps.sales.list, this.state.rowsPerPage), column: nextProps.sales.sortColumn, direction: nextProps.sales.sortDirection });
    }
  }

  handleSalesReportsSelect = (id, e) => {
    // e.preventDefault();
    this.props.getSalesReportsById(id);
  }


  handleSort = (clickedColumn) => () => {
    this.props.sortSalesReports(clickedColumn);
  }

  handleGenerateStatement() {
    let data = {
      stmt_date: new Date(),
      start_date: moment(this.props.sales.startDate).toDate(),
      end_date: moment(this.props.sales.endDate).toDate(),
      num_pages: this.state.data.length,
      rowsPerPage: this.state.rowsPerPage,
      pages: this.state.data,
      summary: this.state.summary
    };
    let html = window.Handlebars.templates.statement(data);
    console.log(this.state.data);
    let strWindowFeatures = "menubar=yes,location=no,resizable=no,scrollbars=yes,status=no";
    // window.open(window.location.hostname + ':' + window.location.port + html, "_blank", strWindowFeatures);
    let stmt_wnd = window.open("", "_blank");
    stmt_wnd.document.write(html);
  }

  handleInputChange(e, data) {
    console.log(e);
    console.log(data);
    this.setState({
      [data.id]: data.value
    });
  }

  render() {
    const { summary, data, page, column, direction, rowsPerPage, length, selectedStartDate, selectedEndDate, series, options } = this.state;

    return (
      <Fragment>

        {/* Date Picker */}
        <Table style={{ border: '0px' }}>
          <Table.Row>
            <Table.Cell width={4}>
              {/* Start Date */}
              Start Date
              <DatePicker
                dateFormat="dd/MM/yyyy"
                selected={this.state.startDate}
                selectsStart
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                onChange={this.handleChangeStart}
                isClearable={false}
                // placeholderText="Cleared!"
                todayButton={"Today"}
                showMonthDropdown
                customInput={<DatePickerInput value={props.value} onClick={props.onClick} />}
              />
            </Table.Cell>
            {/* End Date */}
            <Table.Cell width={4}>
              End Date
              <DatePicker
                dateFormat="dd/MM/yyyy"
                selected={this.state.endDate} //when day is clicked
                selectsEnd
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                onChange={this.handleChangeEnd} //only when value has changed
                minDate={this.state.startDate}
                isClearable={false}
                // placeholderText="Cleared!"
                todayButton={"Today"}
                showMonthDropdown
                customInput={<DatePickerInput value={props.value} onClick={props.onClick} />}
              />
            </Table.Cell>
            <Table.Cell width={1}>
            </Table.Cell>
            <Table.Cell style={{ margin: '5px 0px 0em' }} width={4}>
              <Button primary onClick={this.handleGetSalesReports.bind(this)}>Get Report</Button>
              <Button primary onClick={this.handleGenerateStatement.bind(this)}>Print Report</Button>
            </Table.Cell>
          </Table.Row>
        </Table>
        <br />
        <div><h2>Sales Summary <i style={{ fontSize: '0.75em' }}>( {moment(selectedStartDate).format('DD/MM/YYYY')} - {moment(selectedEndDate).format('DD/MM/YYYY')} )</i></h2></div>
        <div>
          <Table celled structured>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>No. of Transaction</Table.HeaderCell>
                <Table.HeaderCell>Total Sales</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {summary
                ?
                (
                  <Table.Row>
                    <Table.Cell>{summary.count}</Table.Cell>
                    <Table.Cell>RM {summary.sum.toFixed(2)}</Table.Cell>
                  </Table.Row>
                )
                :
                (
                  <Table.Row>
                    <Table.Cell colSpan="2" textAlign="center" >No Data</Table.Cell>
                  </Table.Row>
                )
              }
            </Table.Body>
          </Table>
        </div>

        {series.length > 0 ? (<ReactApexChart options={options} series={series} type="pie" width="380" />) : (<h2>No Records in Pie Chart</h2>)}

        <br />

        <h2>Sales Records</h2>
        <Table sortable celled structured selectable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell sorted={column === 'order_date' ? direction : null} onClick={this.handleSort('order_date')}>
                Date
              </Table.HeaderCell>
              <Table.HeaderCell sorted={column === 'id' ? direction : null} onClick={this.handleSort('id')}>
                Invoice No.
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="right" sorted={column === 'order_details.total_amount' ? direction : null} onClick={this.handleSort('order_details.total_amount')}>
                Total Amount (RM)
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {data && data[page] &&
              (data.length > 0) ?
              data[page].map((sales, index) => {
                return (
                  // To have a key to loop the data out.
                  <Table.Row key={index}>
                    {/* if statement: before ? is conditon
                                        after ? is true statement
                                        after : is false statment */}
                    <Table.Cell>{sales.order_date ? moment(sales.order_date).format('DD/MM/YYYY HH:mm') : 'NIL'}</Table.Cell>
                    <Table.Cell>{sales._id}</Table.Cell>
                    <Table.Cell textAlign="right" >{sales.order_details.total_amount.toFixed(2)}</Table.Cell>
                  </Table.Row>
                )
              }) :
              <Table.Row>
                <Table.Cell colSpan="3" textAlign="center">
                  No Record Found
                </Table.Cell>
              </Table.Row>
            }
          </Table.Body>
        </Table>

        <Pagination style={{ float: 'right' }} activePage={page + 1} totalPages={Math.ceil(length / rowsPerPage)} onPageChange={(e, data) => this.setState({ page: data.activePage - 1 })} />
      </Fragment>
    );
  }
}

const DatePickerInput = ({ value, onClick }) => (
  <Input
    name="requestedDate"
    value={value}
    placeholder="Date"
    onClick={onClick}
    // classNameName="calendar-input"
    style={{ margin: '5px', cursor: 'pointer' }}
    autoComplete="false"
    readOnly={true}
  />
);

const mapStateToProps = ({ sales }) => {
  return { sales }
}

const matchDispatchToProps = (dispatch) => {
  return bindActionCreators({
    setActivePage: setActivePage,
    showLoading: showLoading,
    hideLoading: hideLoading,
    getSalesReports: getSalesReports,
    getSalesReportsById: getSalesReportsById,
    sortSalesReports: sortSalesReports,
    exportSales: exportSales
  }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(SalesReport);
